import React, { useState } from "react";

function SignupTerms({ onNext }) {
  const [formData, setFormData] = useState({
    termsAgreed: false,
    privacyAgreed: false,
    name: ""
  });
  const [errors, setErrors] = useState({});

  const handleCheckboxChange = (field, checked) => {
    setFormData(prev => ({
      ...prev,
      [field]: checked
    }));
    
    // Clear error when user checks the box
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    
    // Allow typing in any language but store the value
    setFormData(prev => ({
      ...prev,
      name: value
    }));
    
    // Clear error when user starts typing
    if (errors.name) {
      setErrors(prev => ({
        ...prev,
        name: ''
      }));
    }
  };

  // Check if current step is valid (same logic as SignUpPC.jsx)
  const isCurrentStepValid = () => {
    return formData.termsAgreed && 
           formData.privacyAgreed && 
           formData.name.trim() && 
           formData.name.length >= 2 &&
           /^[가-힣]+$/.test(formData.name.trim());
  };

  const handleNext = () => {
    const newErrors = {};
    
    if (!formData.termsAgreed) {
      newErrors.termsAgreed = '이용약관에 동의해주세요.';
    }
    if (!formData.privacyAgreed) {
      newErrors.privacyAgreed = '개인정보 수집·이용에 동의해주세요.';
    }
    if (!formData.name.trim()) {
      newErrors.name = '이름을 입력해주세요.';
    } else if (formData.name.length < 2) {
      newErrors.name = '이름은 2자 이상 입력해주세요.';
    } else {
      // Korean characters only validation (same as SignUpPC.jsx)
      const koreanRegex = /^[가-힣]+$/;
      if (!koreanRegex.test(formData.name.trim())) {
        newErrors.name = '이름은 한글만 입력해주세요.';
      }
    }
    
    setErrors(newErrors);
    
    if (Object.keys(newErrors).length === 0) {
      // Pass the name data to the next step
      onNext({ name: formData.name });
    }
  };
   return (
    <div className="signup-terms">
      <section className="terms-section">
        <h3 className="terms-title">이용약관</h3>
        <div className="terms-box">
          <div className="terms-inside-box">
          <p className="terms-regular-font">
          아래의 이용약관은 강화파라다이스를 이용하시는 고객님의 권익 보호와 공정한 거래를 위해 제정되었습니다.고객님의 입장에 서서 최대한 안전하고 편리한 쇼핑 서비스를 제공하기 위해 노력하겠습니다.
          </p>
          <p className="terms-font-two">
            약관 (공정거래위원회 표준약관 제10032호)
            <div className="terms-font-span">
            <span>제1장 총 칙</span>
            </div>
            <br />
            <span>제1조(목적)</span>
            </p>
             <p className="terms-regular-font">
            이 약관은 (주)강화파라다이스(이하 "회사"한다)가 회원약관에 동의한 모든 회원 및 인터넷 관련 서비스(이하 "서비스"라 한다)를 이용함에 있어 웹사이트와 이용자의 권리의무 및 책임사항을 규정함을 목적으로 합니다.
          </p>
          </div>
          <div className="terms-font-two">
          <p>제2조(정의)</p>
        </div>
        <div className="terms-regular-font list-box">
        <ol>
          <li>웹사이트 : "회사"가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장 혹은 웹사이트을 운영하는 사업자</li>
          <li>이용자 : "웹사이트"에 접속하여 이 약관에 따라 "웹사이트"가 제공하는 서비스를 받는 회원 및 비회원</li>
          <li>회원 : "웹사이트"의 회원약관에 동의하여 "회사"에 개인정보를 제공하여 이용계약을 체결한 모든 회원을 지칭하며, "웹사이트"의 정보를 지속적으로 제공받으며, "웹사이트"가 제공하는 서비스를 계속적으로 이용할 수 있는 자</li>
          <li>비회원 : 회원에 가입하지 않고 "웹사이트"가 제공하는 서비스를 이용하는 자</li>
        </ol>
        </div>
        </div>
        {/* </div>  */}
        <label className="mobile-checkbox-label">
           <input 
            type="checkbox" 
            checked={formData.termsAgreed}
            onChange={(e) => handleCheckboxChange('termsAgreed', e.target.checked)}
          />
          <span className="mobile-custom-checkbox"></span>
          <span>이용약관에 동의합니다.</span>
         
        </label>
        {errors.termsAgreed && <div className="mobile-error-msg">{errors.termsAgreed}</div>}
      </section>
      
      <section className="terms-section">
        <h3 className="terms-title">개인정보 수집·이용안내</h3>
        <div className="terms-box">
          <div className="terms-inside-box">
           <p className="terms-font-sub-two">개인정보의 수집,이용목적</p>
          {/* <p className="terms-font-sub">개인정보의 수집, 이용목적</p> */}
           <ol className="ordered-list">
           <li>서비스 이용에 따른 본인식별, 실명확인, 가입의사확인, 연령제한 서비스이용</li>
            <li>고지사항 전달, 불만처리 의사소통 경로 확보, 물품배송 시 정확한 배송지 정보 확보</li>
            <li>신규 서비스등 최신정보 안내 및 개인맞춤서비스 제공을 위한 자료</li>
            <li>유료정보 이용에 대한 요금결제</li>
            <li>불량회원 부정이용 방지 및 비인가 사용방지</li>
            <li>기타 원활한 양질의 서비스 제공등</li>
          </ol>
          {/* <p className="terms-font-sub">수집하는 개인정보의 항목</p> */}
        </div>
        </div>

        <label className="mobile-checkbox-label">
          <input 
            type="checkbox" 
            checked={formData.privacyAgreed}
            onChange={(e) => handleCheckboxChange('privacyAgreed', e.target.checked)}
          />
         
          <span className="mobile-custom-checkbox"></span>
            <span>개인정보 수집 및 이용에 동의합니다.</span>
        </label>
        {errors.privacyAgreed && <div className="mobile-error-msg">{errors.privacyAgreed}</div>}
      </section>
      
      <div className="mobile-input-label">이름(실명)입력</div>
      <div className="mobile-input-group">
        <input 
          type="text" 
          id="user-name"
          placeholder="이름을 입력하세요" 
          value={formData.name}
          onChange={handleNameChange}
        />
      </div>
      {errors.name && <div className="mobile-error-msg">{errors.name}</div>}
      
      <button 
        className="mobile-next-btn" 
        onClick={handleNext}
        disabled={!isCurrentStepValid()}
      >
        다음단계로
      </button>
    </div>
  );
}

export default SignupTerms; 